import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.AnnouncementsPage.title',
    defaultMessage: 'Announcements',
  },
  subtitle: {
    id: 'containers.AnnouncementsPage.subtitle',
    defaultMessage: 'Chronological release history for all VoiceArchive in-house software and platforms.',
  },
  new: {
    id: 'containers.AnnouncementsPage.new',
    defaultMessage: 'New',
  },
  featureFlagLink: {
    id: 'containers.AnnouncementsPage.featureFlagLink',
    defaultMessage: 'Go to settings to enable feature',
  },
})
